import { isEmptyIntroduction } from "../../../pages/editor/components/chat-editor/components/editer-content/types/show/components/editor-chat-content"
import { EDIT_TYPE, IEditorContent } from "../../../pages/editor/types"
import { Content, Types } from "../../../rpcs/dist/EpisodeRPC"

export const ConvertContentFromEditorContent = (
  editorContents: IEditorContent[],
): Content[] => {
  return editorContents
    .filter(e => e._editMetaData.type !== EDIT_TYPE.REMOVE)
    .filter(e => !isEmptyIntroduction(e))
    .map(e => {
      const content: Content = {
        uuid: e.uuid,
        postedAt: e.postedAt,
        userId: e.userId,
        type: e.type,
        blockStyle: e.blockStyle,
        blocks: e.blocks,
      }
      if (e.type === Types.Pickup) {
        content.pickedUserId = e.pickedUserId
      }
      if (e.type === Types.Quotation) {
        content.quote = e.quote
      }
      if (e.type === Types.Survey) {
        content.survey = e.survey
      }
      return content
    })
}
